import React, { Component, Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as usersActions from '../../redux/actions/usersActions';
import { bodyScroll } from '../../utils/utils';
import { userIsAdmin } from '../../utils/permissionsOptions';

import InviteUserModal from '../features/account/InviteUserModal';
import ChangePasswordModal from '../features/account/ChangePasswordModal';
import AccountCards from '../features/account/AccountCards';

class AccountPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showInviteUserModal: false,
      showChangePasswordModal: false,
    };
  }

  componentDidMount() {
    const { dispatchUsersActions } = this.props;

    dispatchUsersActions.getUsers();
  }

  toggleInviteUserModal = () => {
    bodyScroll.toggle();
    this.setState(prevState => ({ showInviteUserModal: !prevState.showInviteUserModal }));
  }

  toggleChangePasswordModal = () => {
    bodyScroll.toggle();
    this.setState(prevState => ({ showChangePasswordModal: !prevState.showChangePasswordModal }));
  }

  render() {
    const { user, dispatchUsersActions } = this.props;
    const { showInviteUserModal, showChangePasswordModal } = this.state;

    return (
      <Fragment>
        <Helmet>
          <title>Manage Account</title>
        </Helmet>
        <div className="page-header">
          <div className="row">
            <h1 className="page-header__heading">Manage Account</h1>
          </div>
        </div>
        <div className="account dashboard-content row">
          <AccountCards
            toggleChangePasswordModal={this.toggleChangePasswordModal}
          />
          {userIsAdmin(user) && (
            <div className="dashboard-content__sidebar">
              <button
                type="button"
                onClick={this.toggleInviteUserModal}
                className="button button--full-width button--large button--brand dashboard-content__button"
              >
                Invite Users
              </button>
              <p className="dashboard-content__text">
                Invite a colleague to become a user. Users can make observations, complete assessments, and review&nbsp;data.
              </p>
              <Link
                to="/account/users"
                className="button button--full-width button--large dashboard-content__button"
              >
                Manage Users
              </Link>
              <p className="dashboard-content__text">
                View and edit permission levels  for&nbsp;users.
              </p>
            </div>
          )}
        </div>
        <InviteUserModal
          visible={showInviteUserModal}
          toggleInviteUserModal={this.toggleInviteUserModal}
          usersActions={dispatchUsersActions}
        />
        <ChangePasswordModal
          visible={showChangePasswordModal}
          toggleChangePasswordModal={this.toggleChangePasswordModal}
          usersActions={dispatchUsersActions}
        />
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return { user: state.users.roster[state.users.currentUserId] || {} };
}

function mapDispatchToProps(dispatch) {
  return { dispatchUsersActions: bindActionCreators(usersActions, dispatch) };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AccountPage);



// WEBPACK FOOTER //
// ./src/components/pages/AccountPage.js